import mapboxgl from 'mapbox-gl';

$(function() {
    mapboxgl.accessToken = 'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNtMW9wZmh0ZzEycHkya3F0ZjRzdTc1bjkifQ.SvrLN7VjyuPLx38qGtCJHA';
    const mapbox = $('.locaties__map');
    if (!mapbox.length) {
        return;
    }

    const center_lat = '51.414177';
    const center_lng = '3.866360';
    const map = new mapboxgl.Map({
        container: mapbox.get(0),
        style: 'mapbox://styles/blackdesk/ckf3r6olg0y3z19oab1np6zql',
        center: new mapboxgl.LngLat(center_lng, center_lat),
        maxZoom: 18,
        zoom: 8,
        minZoom: 6,
    });

    const markers = $('.locaties__map__marker');
    markers.each(function () {
        const marker = document.createElement('div');
        const markerPosition = new mapboxgl.LngLat($(this).data('lng'), $(this).data('lat'));
        marker.className = 'marker';
        marker.style.backgroundImage = 'url(/wp-content/themes/cappendijk/resources/images/mapbox_marker.svg)';
        const size = 32;
        marker.style.width = size + 'px';
        marker.style.height = size + 'px';
        marker.style.top = '-' + size / 2 + 'px';
        marker.style.backgroundSize = 'contain';
        marker.style.backgroundRepeat = 'no-repeat';
        marker.style.backgroundPosition = 'center center';
        new mapboxgl.Marker(marker).setLngLat(markerPosition).addTo(map);
    });
});
